var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-detail"},[_c('common-head'),_c('div',{staticClass:"my-wrap"},[_c('div',{staticClass:"my-html",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }